// extracted by mini-css-extract-plugin
export default {"wrapper":"Card_wrapper__klqq5","number":"Card_number__CGWuK","right":"Card_right__BNSEp","title":"Card_title__IV+Kq","description":"Card_description__ftRsH","img":"Card_img__6bWTk"};